import _nsnMethods from './nsnMethods';

/**
 * this closure starts the application
 * under a bunch of different conditions
 * checking for:
 * - current local storage
 * - userid in the query params
 * - lack of local storage
 *
 * based on these conditions, the app will
 * start differently
 */
const _initApp = (function () {
    function Init(props) {
        const {
            search,
            sfIntegration,
            ds,
            storage,
            aiMethods,
            subjectFinderSkeleton,
            helpers,
            globals,
            snapshot,
            dsIntegration,
            nsnMethods,
        } = props;

        /**
         * start the app
         *
         * @param {object} stored
         * if there is current locally stored data
         *
         * @return {void}
         */
        this.startApp = function (stored, callback) {
            const queryParams = search.split(/\?|&/g);
            const userid = queryParams.filter((param) =>
                param.match(/userid=/)
            );

            if (stored && !userid.length) {
                // populate fields with data from local storage
                sfIntegration.applyData.bind(this)();

                const storedVersion = Number(stored.version);
                const currentVersion = Number(subjectFinderSkeleton.version);

                if (storedVersion < currentVersion) {
                    storage.set(subjectFinderSkeleton);
                    window.location.reload();
                }

                globals.storageSnapshot = snapshot.set(stored);

                if (stored.results && stored.results.length) {
                    aiMethods.buildAiResults.bind(this)(stored.results);
                }

                // globals.storageSnapshot = encodeURIComponent(
                // JSON.stringify(stored)
                // );

                // set what pages/sections are visible
                sfIntegration.pageStates.bind(this)(stored);

                // if(stored.academic.questions['nsn-api-best-subject']) {
                //     this.include({
                //         pages: ['nsn-api-best-subject']
                //     });

                //     window.nsnRetrieved = true;
                // }

                this.setStart({
                    page: stored.lastPage,
                });

                setTimeout(() => {
                    helpers.validEmail.bind(this)();
                }, 0);
            } else {
                if (userid.length) {
                    const emailWrapper =
                        document.querySelector(`.subscription-card`);
                    const id = userid[0].replace(/userid=/g, '');
                    const surveyLink = document.querySelector(
                        `[data-role="survey-link"]`
                    );

                    window.userUid = id;
                    emailWrapper.classList.add('hidden');
                    // surveyLink.href = `${surveyLink.href}?id=${id}`;

                    // FOR LOCAL TESTING
                    if (origin.match(/localhost/gi)) {
                        ds.collection('subject-finder-items')
                            .doc(id)
                            .get()
                            .then((json) => {
                                const userData = JSON.parse(
                                    decodeURIComponent(json.subject_finder_data)
                                );

                                // globals.storageSnapshot = encodeURIComponent(
                                // JSON.stringify(userData)
                                // );

                                const storedVersion = Number(userData.version);
                                const currentVersion = Number(
                                    subjectFinderSkeleton.version
                                );

                                if (storedVersion < currentVersion) {
                                    storage.set(subjectFinderSkeleton);

                                    dsIntegration.updateUserData();
                                    window.location.reload();

                                    return;
                                }

                                storage.set(userData);

                                globals.storageSnapshot =
                                    snapshot.set(userData);

                                if (
                                    userData.results &&
                                    userData.results.length
                                ) {
                                    aiMethods.buildAiResults.bind(this)(
                                        userData.results
                                    );
                                }

                                // populate fields with data from local storage
                                sfIntegration.applyData.bind(this)();

                                // set what pages/sections are visible
                                sfIntegration.pageStates.bind(this)(stored);

                                // logic functions to react to the state
                                // since we could be starting at the end

                                // go to the last page
                                this.setStart(
                                    {
                                        page: userData.lastPage,
                                    },
                                    true
                                );

                                // show/hide nodes that live outside the view
                                // of the application
                                sfIntegration.outerSectionNodes.bind(this)();

                                // make sure the navigation controls display correctly
                                sfIntegration.navControls.bind(this)();

                                // aiMethods.buildAIPostBodyData.bind(this)();
                            })
                            .catch((err) => {
                                // window.location.href =
                                // window.location.href = origin + search.replace(/(\?|&)userid=.*(?=&)|userid=.*/g, "");
                                storage.set(subjectFinderSkeleton);

                                window.location.href =
                                    window.location.href.replace(
                                        /(\?|&)userid=.*(?=&)|userid=.*/g,
                                        ''
                                    );

                                throw new Error(err);
                            });

                        return;
                    }

                    // LIVE SITE
                    fetch(
                        `${origin}/_design/integration-points/subject-finder-subject-list/get-user-data?userid=${id}`
                    )
                        .then((data) => data.json())
                        .then((json) => {
                            if (json && json.subject_finder_data) {
                                const userData = JSON.parse(
                                    decodeURIComponent(json.subject_finder_data)
                                );

                                const storedVersion = Number(userData.version);
                                const currentVersion = Number(
                                    subjectFinderSkeleton.version
                                );

                                if (storedVersion < currentVersion) {
                                    storage.set(subjectFinderSkeleton);

                                    dsIntegration.updateUserData(() => {
                                        window.location.reload();
                                    });

                                    return;
                                }

                                userData.userUid = id;

                                storage.set(userData);

                                globals.storageSnapshot =
                                    snapshot.set(userData);

                                // globals.storageSnapshot = encodeURIComponent(
                                // JSON.stringify(userData)
                                // );

                                if (
                                    userData.results &&
                                    userData.results.length
                                ) {
                                    aiMethods.buildAiResults.bind(this)(
                                        userData.results
                                    );
                                }

                                // populate fields with data from local storage
                                sfIntegration.applyData.bind(this)();

                                // set what pages/sections are visible
                                sfIntegration.pageStates.bind(this)(stored);

                                // logic functions to react to the state
                                // since we could be starting at the end

                                // go to the last page
                                this.setStart(
                                    {
                                        page: userData.lastPage,
                                    },
                                    true
                                );

                                // show/hide nodes that live outside the view
                                // of the application
                                sfIntegration.outerSectionNodes.bind(this)();

                                // make sure the navigation controls display correctly
                                sfIntegration.navControls.bind(this)();

                                // aiMethods.buildAIPostBodyData.bind(this)();

                                return;
                            }

                            // if the user's data has been removed (after 6 months)
                            // get the subject finder skeleton

                            // set the local storage object
                            storage.set(subjectFinderSkeleton);

                            // populate fields with data from local storage
                            sfIntegration.applyData.bind(this)();

                            // set what pages/sections are visible
                            sfIntegration.pageStates.bind(this)(stored);
                        })
                        .catch((err) => {
                            throw new Error(err);
                        });

                    return;
                }

                // set the local storage object
                storage.set(subjectFinderSkeleton);

                // populate fields with data from local storage
                sfIntegration.applyData.bind(this)();

                // set what pages/sections are visible
                sfIntegration.pageStates.bind(this)(stored);
            }
        };
    }

    return (props) => {
        return new Init(props);
    };
})();

export default _initApp;
